import { render, staticRenderFns } from "./AdWorkspace.vue?vue&type=template&id=63116868&scoped=true&"
import script from "./AdWorkspace.vue?vue&type=script&lang=js&"
export * from "./AdWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./AdWorkspace.vue?vue&type=style&index=0&id=63116868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63116868",
  null
  
)

export default component.exports